export const FIDELITY_TOOLTIP_CONTENT = (
  <p>
    Paid non-advisory client promotion. NerdWallet maintains a 401k program and equity management
    program through affiliates of this provider; NerdWallet doesn't invest its money with this
    provider, but they are our referral partner - so we get paid only if you click through and take
    a qualifying action. Being a referral partner influences which products we write about and where
    and how the product appears on our webpage. Most importantly, however, the content of our
    reviews and ratings are objective and are never impacted by our partnerships. Our opinions are
    our own. Here is a <a href="https://www.nerdwallet.com/p/our-partners">list of our partners</a>{' '}
    and <a href="https://www.nerdwallet.com/p/advertiser-disclosure">here’s how we make money</a>.
  </p>
);

export const BASE_RIA_TOOLTIP_CONTENT = (
  <p>
    NerdWallet doesn’t invest its money with this provider, but they are our referral partner – so
    we get paid only if you click through and take a qualifying action (such as open an account with
    or provide your contact information to the provider). Most importantly, our reviews and ratings
    are objective and are never impacted by our partnerships. Our opinions are our own. Here is a
    list of <a href="https://www.nerdwallet.com/p/our-partners">our partners</a> and{' '}
    <a href="https://www.nerdwallet.com/p/advertiser-disclosure">here’s how we make money</a>.
  </p>
);
